export default {
  data() {
    return {
      attrParamKeyMap: {
        acCurrentFlowingThroughTheTestPieceDensityShow: '流经试片交流电流密度（A / m²）',
        acCurrentFlowingThroughTheTestPieceShow: '交流电流',
        acInterferenceVoltageShow: '交流干扰电压',
        batteryLevelShow: '剩余电量（%）',
        batteryVoltageShow: '电池电压',
        directCurrentFlowingThroughTheTestPieceDensityShow: '流经试片直流电流密度（mA / cm²）',
        directCurrentFlowingThroughTheTestPieceShow: '直流电流',
        sacrificialAnodeShow: '牺牲阳极（mA）',
        sacrificialAnodeVoltageShow: '牺牲阳极',
        selfCorrosionPotentialShow: '自自腐蚀电位',
        signalStrengthShow: '信号强度（%）',
        electrifiedPotentialShow: '通电电位',
        voffShow: '断电电位'
      }
    }
  }
}
